import{j as o,m as r}from"./chunk-HBP5N4FR.js";r();var c=(i,m,t)=>o(void 0,null,function*(){let e;return Promise.race([i,new Promise((s,n)=>e=setTimeout(n,m,t))]).finally(()=>clearTimeout(e))});export{c as a};
//# sourceMappingURL=chunk-LO5NNAIV.js.map
